console.log('✅ catalog-listing-image-slider.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState } from '../../js/state.js';
import { getTextTranslationByKey } from '../../js/translator.js';
import {
  getLinksTranslationByKey,
  getLinksTranslationByKeySingleWord,
} from '../../js/router-routes-manager.js';
import {
  saveToLocalStorage,
  loadFromLocalStorage,
  saveToLocalStorageWithLimitAndExpiry,
} from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentCategoryCard } from '../cards/category-card.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import { convertStringToInt } from '../../js/utils-convert-numbers.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';
import {
  fetchAddItemToWishList,
  fetchCheckIfSKUIsInWishList,
  fetchRemoveItemFromWishList,
} from '../../services/data-services/shopping-cart-data-service.js';

//let _tempTextTranslator = null;
//export async function initTempTextTranslator(lang) {
//    _tempTextTranslator = await loadTextTranslations(lang);
//}

//let _tempLinksTranslator = null;
//export async function initTempLinksTranslator(lang) {
//    _tempLinksTranslator = await initLinksTranslator(lang);
//}

let isInWishList = false;
let currentListingImageSelectedSliderIndex = 0;

// swipe handling names
let pointerDownName = 'pointerdown';
let pointerUpName = 'pointerup';
let pointerMoveName = 'pointermove';

let initialTouchPos = null;
let lastTouchPos = null;

export async function buildComponentCatalogListingImageSlider(
  listingModeIsLive,
  selectedSKU,
  shareUrl,
  departmentID,
  categoryID,
  productID
) {
  console.log(
    `🔄 Building Component: CatalogListingImageSlider - lang: ${appState.SiteLanguageCookie}`
  );

  listingModeIsLive = true;

  try {
    // Dynamically import the shared helper,
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "translation-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    //  await initTempTextTranslator(appState.SiteLanguageCookie);
    // await initTempLinksTranslator(appState.SiteLanguageCookie);

    // let inWishlist = false;

    // returns {myBool: true} or {myBool: false}
    let checkifSKUIsInWishList = await fetchCheckIfSKUIsInWishList(selectedSKU.skuid);

    // alert(`checkifSKUIsInWishList ${JSON.stringify(checkifSKUIsInWishList)}`);

    if (checkifSKUIsInWishList && checkifSKUIsInWishList.myBool) {
      isInWishList = checkifSKUIsInWishList.myBool;
    } else {
      isInWishList = false;
    }

    // collect all image/video filenames
    let media = [];

    if (selectedSKU) {
      media = [
        selectedSKU.image1FileName,
        selectedSKU.image2FileName,
        selectedSKU.image3FileName,
        selectedSKU.image4FileName,
        selectedSKU.image5FileName,
        selectedSKU.image6FileName,
        selectedSKU.image7FileName,
        selectedSKU.image8FileName,
        selectedSKU.image9FileName,
        selectedSKU.image10FileName,
        selectedSKU.image11FileName,
        selectedSKU.image12FileName,
      ].filter(f => f && f.trim());
    } else {
      console.error('No selectedSKU provided for product image slider');

      selectedSKU = {
        image1FileName: `${APP_CONFIG.IMAGES_BASE_URL}imgs/products/featured-image.png`,
        image2FileName: '',
        image3FileName: '',
        image4FileName: '',
        image5FileName: '',
        image6FileName: '',
        image7FileName: '',
        image8FileName: '',
        image9FileName: '',
        image10FileName: '',
        image11FileName: '',
        image12FileName: '',
      };
    }

    const html = `

         <div class="imageproductXXX">

         <div class="imageproductXXXL2">
       
        <div class="ProductForSaleAreaHeaderphoto-main">
          <div class="ActualProductForSaleAreaHeaderControls">
            <input type="text" value="${shareUrl}" id="lblShareSKUURL" style="display:none;">
            <input type="text" value="${departmentID}" id="lblShareSKUDepartment" style="display:none;">
            <input type="text" value="${categoryID}" id="lblShareSKUCategory" style="display:none;">
            <input type="text" value="${productID}" id="lblShareSKUProduct" style="display:none;">
            <input type="text" value="${
              selectedSKU.skuid
            }" id="lblShareSKUSKU" style="display:none;">


            <div class="tooltipxParent">
              <a id="btnShare"><img src="${
                APP_CONFIG.IMAGES_BASE_URL
              }imgs/icons/svg/share.svg" width="40" height="40" class="svgiconsOnTop" alt="Share Link"></a>
              <div class="tooltipx" id="lblShareSKUURLToolTip">Copied</div>
            </div>
            
                 <div class="tooltipxParent">
                   <a id="btnAddWishlist" class="share-popup"><img src="${
                     APP_CONFIG.IMAGES_BASE_URL
                   }imgs/icons/svg/heart.svg" width="40" height="40" class="svgiconsOnTop" alt="Add to Wishlist"></a>
                   <div class="tooltipx-right" id="lblAddToWishListToolTip">Added To Wishlist</div>
                 </div>
        
          </div>
        </div>

        <div id="featuredImage-wrapper">
         <div id="FeaturedImage">
          <img id="mainImage" src="${
            selectedSKU.image1FileName
          }" width="450" height="410" class="FeaturedImage unhideFeaturedImageOrVideo" alt="Product Main Image">
          </div>
          <div id="FeaturedVideo">
           <video    id="mainVideo"    controls    playsinline    class="FeaturedVideoElement"   width="450" height="410"  ></video>
           
          </div>
        </div>
       

        <div class="ProductSlider-wrapper-holder">
          <div id="ProductSlider-wrapper">
            <a class="SliderArrows2" id="slideLeft">&#10094;</a>
            <div id="ProductSliderslider">
              ${media
                .map(
                  (src, i) => `
                <div class="thumbnailSliderImage${
                  i === 0 ? ' ActiveThumbnail' : ''
                }" data-index="${i}">
                  ${
                    src.endsWith('.mp4')
                      ? `<div class="divWithOverlay">
                         <div class="videoThumbnail"><img width="53" height="53" src="${src}" style="display:none;"></div>
                         <div class="playBtnOverlay"></div>
                       </div>`
                      : `<img  width="53" height="53" src="${src}" class="thumbnailSliderImageOnlyClass">`
                  }
                </div>
              `
                )
                .join('')}
            </div>
            <a class="SliderArrows2" id="slideRight">&#10095;</a>
          </div>
        </div>
        </div>
       
      </div>
      `;

    // Register event listeners
    // registerEventListenerToAttach(attachEventListenersCatalogProducts);
    registerEventListenerToAttach(async () => attachMainEventListenersForThisComponent());

    return html;
  } catch (err) {
    console.error('❌ Error building ComponentCatalogListing:', err);
    return '<div>Error loading ComponentCatalogListing </div>';
  }
}

async function attachMainEventListenersForThisComponent() {
  try {
    console.log('✅ CatalogListingImageSlider event listeners attached.');

    //  await setupApplyToogleButtonListeners();

    await setupAllSliderListeners();

    await setupAllSwipeListeners();

    // set up wishlist button on first load
    handleWishlistButtonOnFirstLoad();

    //set the right and left buttons to be hidden or shown on first load
    _checkScrollArrows();
  } catch (error) {
    console.error('❌ Error attaching event listeners to CatalogListingImageSlider:', error);
  }
}

export async function setupAllSliderListeners() {
  const thumbnails = Array.from(document.getElementsByClassName('thumbnailSliderImage'));

  if (thumbnails.length > 0) {
    thumbnails.forEach((thumb, i) => {
      const onThumbnailClick = async () => await handleUpdateFeaturedImage(i);
      thumb.removeEventListener('click', onThumbnailClick);
      thumb.addEventListener('click', onThumbnailClick);
    });
  }

  const shareBtn = document.getElementById('btnShare');
  if (shareBtn) {
    const onShareClick = async () => handleUpdateShareButton();
    shareBtn.removeEventListener('click', onShareClick);
    shareBtn.addEventListener('click', onShareClick);
  }

  const wishlistBtn = document.getElementById('btnAddWishlist');
  if (wishlistBtn) {
    const onWishlistClick = async () => handleToogleWishlistButton();
    wishlistBtn.removeEventListener('click', onWishlistClick);
    wishlistBtn.addEventListener('click', onWishlistClick);
  }

  const leftArrow = document.getElementById('slideLeft');
  if (leftArrow) {
    const onSlideLeftClick = async () => _scrollSliderBy(-180);
    leftArrow.removeEventListener('click', onSlideLeftClick);
    leftArrow.addEventListener('click', onSlideLeftClick);
  }

  const rightArrow = document.getElementById('slideRight');
  if (rightArrow) {
    const onSlideRightClick = async () => _scrollSliderBy(180);
    rightArrow.removeEventListener('click', onSlideRightClick);
    rightArrow.addEventListener('click', onSlideRightClick);
  }
}

//async function setupAllSliderListeners() {

//    const thumbnails = Array.from(document.getElementsByClassName("thumbnailSliderImage"));

//    if (thumbnails) {

//        thumbnails.forEach((thumb, i) => {

//            const clone = thumb.cloneNode(true);
//            thumb.parentNode.replaceChild(clone, thumb);

//            addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//                await handleUpdateFeaturedImage(i);
//            });

//        });

//     }

//    const shareBtn = document.getElementById("btnShare");

//    if (shareBtn) {
//        const clone = shareBtn.cloneNode(true);
//        shareBtn.parentNode.replaceChild(clone, shareBtn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            handleUpdateShareButton();
//        });
//    }

//    const wishlistBtn = document.getElementById("btnAddWishlist");

//    if (wishlistBtn) {
//        const clone = wishlistBtn.cloneNode(true);
//        wishlistBtn.parentNode.replaceChild(clone, wishlistBtn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            handleToogleWishlistButton();
//        });
//    }

//    const leftArrow = document.getElementById("slideLeft");

//    if (leftArrow) {
//        const clone = leftArrow.cloneNode(true);
//        leftArrow.parentNode.replaceChild(clone, leftArrow);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            _scrollSliderBy(-180);

//        });

//    }

//    const rightArrow = document.getElementById("slideRight");

//    if (rightArrow) {
//        const clone = rightArrow.cloneNode(true);
//        rightArrow.parentNode.replaceChild(clone, rightArrow);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//            _scrollSliderBy(180);

//        });

//    }

//}

function _scrollSliderBy(offset) {
  const slider = document.getElementById('ProductSliderslider');
  if (!slider) return;

  slider.scrollBy({ left: offset, behavior: 'smooth' });

  setTimeout(_checkScrollArrows, 300);
}

async function handleUpdateFeaturedImage(idx) {
  const thumbnails = Array.from(document.getElementsByClassName('thumbnailSliderImage'));
  if (!thumbnails) return;

  const featuredWrp = document.getElementById('featuredImage-wrapper');
  if (!featuredWrp) return;

  const featuredImageSection = document.getElementById('FeaturedImage');
  if (!featuredImageSection) return;

  const featuredImg = featuredWrp.querySelector('img');
  if (!featuredImg) return;

  const videoSection = document.getElementById('FeaturedVideo');
  if (!videoSection) return;

  const featuredVid = featuredWrp.querySelector('video#mainVideo');
  if (!featuredVid) return;

  const ACTIVE_CLASS = 'ActiveThumbnail';

  const thumbnailsCount = thumbnails.length;
  // wrap-around
  currentListingImageSelectedSliderIndex = (idx + thumbnailsCount) % thumbnailsCount;

  thumbnails.forEach(t => t.classList.remove(ACTIVE_CLASS));
  const thumb = thumbnails[currentListingImageSelectedSliderIndex];
  thumb.classList.add(ACTIVE_CLASS);

  const src = thumb.querySelector('img').src;

  if (src.endsWith('.mp4')) {
    featuredVid.src = src;
    featuredVid.classList.add('unhideFeaturedImageOrVideo');
    featuredImg.classList.remove('unhideFeaturedImageOrVideo');
  } else {
    featuredImg.src = src;

    featuredVid.classList.remove('unhideFeaturedImageOrVideo');
    featuredImg.classList.add('unhideFeaturedImageOrVideo');
  }

  _centerActiveThumbnail();
}

async function handleUpdateShareButton() {
  const shareTip = document.getElementById('lblShareSKUURLToolTip');
  const shareUrl = document.getElementById('lblShareSKUURL').value;
  const shareBtn = document.getElementById('btnShare');

  if (shareUrl && shareTip && shareBtn) {
    navigator.clipboard.writeText(shareUrl);
    shareTip.classList.add('tooltipxShow');
    setTimeout(() => shareTip.classList.remove('tooltipxShow'), 1300);
  }
}

async function handleWishlistButtonOnFirstLoad() {
  // Dynamically import the shared helper,
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyAddedToWishList: lblAddedToWishList,
    keyRemovedFromWishList: lblRemovedFromWishList,
    keyAddToWishList: lblAddToWishList,
    keyRemoveFromWishList: lblRemoveFromWishList,
  } = _tempTextTranslator;

  const wishlistBtn = document.getElementById('btnAddWishlist');
  const wishListTip = document.getElementById('lblAddToWishListToolTip');

  if (wishlistBtn && wishListTip) {
    isInWishList = !isInWishList;

    wishlistBtn.classList.toggle('svgiconsOnTop-InWishList', isInWishList);
    wishlistBtn.classList.toggle('svgiconsOnTop', !isInWishList);

    wishlistBtn.setAttribute('alt', isInWishList ? lblAddToWishList : lblRemoveFromWishList);
    wishlistBtn.setAttribute('title', isInWishList ? lblAddToWishList : lblRemoveFromWishList);
    wishlistBtn.setAttribute('aria-label', isInWishList ? lblAddToWishList : lblRemoveFromWishList);

    wishListTip.innerText = !isInWishList ? lblAddedToWishList : lblRemovedFromWishList;
  }
}

async function handleToogleWishlistButton() {
  // Dynamically import the shared helper,
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const {
    keyAddedToWishList: lblAddedToWishList,
    keyRemovedFromWishList: lblRemovedFromWishList,
    keyAddToWishList: lblAddToWishList,
    keyRemoveFromWishList: lblRemoveFromWishList,
  } = _tempTextTranslator;

  const wishlistBtn = document.getElementById('btnAddWishlist');
  const wishListTip = document.getElementById('lblAddToWishListToolTip');

  if (wishlistBtn && wishListTip) {
    isInWishList = !isInWishList;

    wishlistBtn.classList.toggle('svgiconsOnTop-InWishList', isInWishList);
    wishlistBtn.classList.toggle('svgiconsOnTop', !isInWishList);

    wishlistBtn.setAttribute('alt', isInWishList ? lblAddToWishList : lblRemoveFromWishList);
    wishlistBtn.setAttribute('title', isInWishList ? lblAddToWishList : lblRemoveFromWishList);
    wishlistBtn.setAttribute('aria-label', isInWishList ? lblAddToWishList : lblRemoveFromWishList);

    wishListTip.innerText = !isInWishList ? lblAddedToWishList : lblRemovedFromWishList;

    wishListTip.classList.add('tooltipxShow');
    setTimeout(() => wishListTip.classList.remove('tooltipxShow'), 1300);

    if (!isInWishList) {
      // alert(`Adding to wishlist`);
      const qtyTextBox = document.getElementById('txtAddToCartQyt');

      let qyt = 0;

      if (qtyTextBox) {
        const qtyValue = qtyTextBox.value;

        // alert(`qtyValue ${qtyValue}`);

        if (qtyValue) {
          qyt = convertStringToInt(qtyValue);
        }

        if (qyt <= 0) {
          qyt = 1;
        }
      }

      let departmentID = 0;
      let categoryID = 0;
      let productID = 0;
      let shippingMethodID = 0;
      let finalSelectedSKU = 0;

      const lblShareSKUCategory = document.getElementById('lblShareSKUCategory');
      const lblShareSKUProduct = document.getElementById('lblShareSKUProduct');
      const lblShareSKUDepartment = document.getElementById('lblShareSKUDepartment');
      const lblShareSKUSKU = document.getElementById('lblShareSKUSKU');

      if (lblShareSKUCategory) {
        categoryID = lblShareSKUCategory.value;
      }

      if (lblShareSKUProduct) {
        productID = lblShareSKUProduct.value;
      }

      if (lblShareSKUDepartment) {
        departmentID = lblShareSKUDepartment.value;
      }

      if (lblShareSKUSKU) {
        finalSelectedSKU = lblShareSKUSKU.value;
      }

      // alert(` 1 Adding to wishlist ${qyt} ${finalSelectedSKU} ${departmentID} ${categoryID} ${productID} ${shippingMethodID}`);

      if (qyt > 0 && finalSelectedSKU > 0) {
        //  alert(` 1 Adding to wishlist ${qyt} ${finalSelectedSKU} ${departmentID} ${categoryID} ${productID} ${shippingMethodID}`);

        await fetchAddItemToWishList(
          qyt,
          finalSelectedSKU,
          departmentID,
          categoryID,
          productID,
          shippingMethodID
        );
      } else {
        //  alert(`Please select a quantity greater than 0`);
      }
    } else {
      let finalSelectedSKU = 0;
      const lblShareSKUSKU = document.getElementById('lblShareSKUSKU');
      if (lblShareSKUSKU) {
        finalSelectedSKU = lblShareSKUSKU.value;
      }
      // alert(` 1 Removing from wishlist ${finalSelectedSKU}`);
      if (finalSelectedSKU > 0) {
        // alert(` 1 Removing from wishlist ${finalSelectedSKU}`);

        await fetchRemoveItemFromWishList(finalSelectedSKU);
      }
    }
  }
}

function setupAllSwipeListeners() {
  _setupSwipeListeners();
}

function _setupSwipeListeners() {
  if (window.navigator.msPointerEnabled) {
    pointerDownName = 'MSPointerDown';
    pointerUpName = 'MSPointerUp';
    pointerMoveName = 'MSPointerMove';
  }

  const featuredImageWrapper = document.getElementById('featuredImage-wrapper');
  if (!featuredImageWrapper) return;

  const add = featuredImageWrapper.addEventListener.bind(featuredImageWrapper);
  if (window.PointerEvent) {
    add(pointerDownName, handleGestureStart, false);
    add(pointerMoveName, handleGestureMove, false);
    add(pointerUpName, handleGestureEnd, false);
    add('pointercancel', handleGestureEnd, false);
  } else {
    add('touchstart', handleGestureStart, false);
    add('touchmove', handleGestureMove, false);
    add('touchend', handleGestureEnd, false);
    add('mousedown', handleGestureStart, false);
  }
}

// Swipe handling helpers
function getGesturePointFromEvent(evt) {
  if (evt.targetTouches) {
    return { x: evt.targetTouches[0].clientX, y: evt.targetTouches[0].clientY };
  }
  return { x: evt.clientX, y: evt.clientY };
}

function handleGestureStart(evt) {
  evt.preventDefault();
  if (evt.touches && evt.touches.length > 1) return;
  if (window.PointerEvent) evt.target.setPointerCapture(evt.pointerId);
  initialTouchPos = getGesturePointFromEvent(evt);
}

function handleGestureMove(evt) {
  if (!initialTouchPos) return;
  lastTouchPos = getGesturePointFromEvent(evt);
}

function handleGestureEnd(evt) {
  if (evt.touches && evt.touches.length > 0) return;
  if (window.PointerEvent) evt.target.releasePointerCapture(evt.pointerId);

  if (!initialTouchPos || !lastTouchPos) return;

  const dx = initialTouchPos.x - lastTouchPos.x;
  if (Math.abs(dx) < 10) {
    initialTouchPos = lastTouchPos = null;
    return;
  }
  if (dx < 0) {
    handleUpdateFeaturedImage(currentListingImageSelectedSliderIndex - 1);
  } else {
    handleUpdateFeaturedImage(currentListingImageSelectedSliderIndex + 1);
  }
  initialTouchPos = lastTouchPos = null;
}

function _checkScrollArrows() {
  const slider = document.getElementById('ProductSliderslider');
  const buttonLeft = document.getElementById('slideLeft');
  const buttonRight = document.getElementById('slideRight');

  if (!slider || !buttonLeft || !buttonRight) return;
  const maxScroll = slider.scrollWidth - slider.clientWidth;
  buttonLeft.classList.toggle('showScrollArrow', slider.scrollLeft > 0);
  buttonRight.classList.toggle('showScrollArrow', slider.scrollLeft < maxScroll);
}

function _centerActiveThumbnail() {
  const slider = document.getElementById('ProductSliderslider');
  const activeThumbnails = Array.from(
    document.getElementsByClassName('thumbnailSliderImage ActiveThumbnail')
  );
  if (!slider || !activeThumbnails) return;

  // scroll slider so first active thumb is centered
  const active = activeThumbnails[0];
  if (!slider || !active) return;
  const sliderRect = slider.getBoundingClientRect();
  const thumbRect = active.getBoundingClientRect();
  const offset = thumbRect.left + thumbRect.width / 2 - (sliderRect.left + sliderRect.width / 2);
  slider.scrollBy({ left: offset, behavior: 'smooth' });

  _checkScrollArrows();
}

/* MyBoolOnlyModel result = await _shoppingCartDataService.CheckIfSKUIsInWishListAsync(tempSkuID, _myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);*/

//   private async Task AddToWishlistClicked()
//{

//    await _myJSListingPageModule.InvokeVoidAsync("ShowAddToWishListToolTip");

//    // 2 seconds required for it to post back else the tooltip will not show as it would have been removed
//    await Task.Delay(500);

//    if (selectedListingMode == "Live") {

//            MyBoolOnlyModel result = await _shoppingCartDataService.AddSKUToWishListAsync(finalSelectedSKU, "1", _myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, selectedDepartmentID.ToString(), selectedCategoryID.ToString(), selectedProductID.ToString(), "0", _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);

//        // ShoppingCartAccess.AddSKUToWishList(finalSelectedSKU, "1", LoggedInUserID, selectedBuyingEntityID, selectedBuyingEntityType, selectedDepartmentID.ToString(), selectedCategoryID.ToString(), selectedProductID.ToString(), "0");

//        //_myEventCallBackState.AddToCartClicked("Grandchild says hi");
//        await _myEventCallBackState.UpdateShoppingCartEventTriggeredAsync();

//        selectedSKUIsInWishList = await CheckIfSKUIsInWishList(finalSelectedSKU);
//    }

//    await Task.Delay(100);

//}

//    private async Task RemoveFromWishlistClicked()
//{

//    await _myJSListingPageModule.InvokeVoidAsync("ShowRemoveFromWishListToolTip");

//    // 2 seconds required for it to post back else the tooltip will not show as it would have been removed
//    await Task.Delay(500);

//    if (selectedListingMode == "Live") {

//            MyBoolOnlyModel result = await _shoppingCartDataService.RemoveSKUFromWishListAsync(finalSelectedSKU, _myUserIdentityInformationService.MyUserID, _myUserIdentityInformationService.MyBuyingEntityID, _myUserIdentityInformationService.MyBuyingEntityType, _myUserIdentityInformationService.SiteLanguageCookie, _currentComponentCancellationTokenSource.Token);

//        // bool success = ShoppingCartAccess.RemoveItemFromWishList(LoggedInUserID, selectedBuyingEntityID, selectedBuyingEntityType, finalSelectedSKU);

//        //_myEventCallBackState.AddToCartClicked("Grandchild says hi");
//        await _myEventCallBackState.UpdateShoppingCartEventTriggeredAsync();

//        selectedSKUIsInWishList = await CheckIfSKUIsInWishList(finalSelectedSKU);

//    }

//    await Task.Delay(100);

//}
